export const DEMO_ACCESS_PASSWORD = "PyCray@247";

export const DEMO_TRIAL_WHATSAPP_URL =
  "https://wa.me/918758379686?text=" +
  encodeURIComponent("Hi PyCray, I'd like to get trial access to your AI demos");
